import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { take, map } from 'rxjs/operators';
import { PhysioService } from './physio.service';
import { isTokenExpired } from '../helpers/token.helper';

@Injectable({
  providedIn: 'root'
})
export class PhysioAuthGuard implements CanActivate {
  constructor(
    private physioService: PhysioService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {

    if (isTokenExpired()) {
      this.physioService.logout();
      return false;
    }

    return this.physioService.isLoggedIn.pipe(take(1),
      map((isLoggedIn: boolean) => {
        let checkOTP = localStorage.getItem('ISOTPVERIFIED') ? true : false;
        let canLogin = isLoggedIn && checkOTP;
        if (!canLogin) {
          // this.router.navigate(['/']); 
          this.physioService.logout();
          return false;
        }
        return true;
      })
    );
  }
}